import { render, staticRenderFns } from "./Adversities.vue?vue&type=template&id=7be3f11e&"
import script from "./Adversities.vue?vue&type=script&lang=js&"
export * from "./Adversities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports